export const FOOD_TYPE = {
  preorder: "PREORDER",
  instant: "INSTANT",
  catering: "CATERING",
};
